module.exports = __webpack_public_path__ + "media/images/og-wimit-d72e38be47b3cc3e3258b45e80b3c470.png";